{
  "languages": {
    "en": "English",
    "pt-BR": "Português (Brasil)"
  },
  "multiSelect": {
    "selectedCount": "Selected ({{total}})"
  },
  "nav": {
    "selectDemoOrganization": "Select Demo Organization",
    "pleaseSelect": "Please select",
    "switchOrgError": "Couldn't switch organization. Please try again.",
    "logout": "Logout",
    "adminView": "Admin View",
    "producerView": "Producer View",
    "switchToAdminView": "Switch to Admin View",
    "switchToProducerView": "Switch to Producer View",
    "toggleDarkMode": "Toggle dark mode"
  },
  "sectionNames": {
    "Administration": "Administration",
    "MEQ Live Admin": "MEQ Live Admin",
    "GMP Lamb Data Analysis": "GMP Lamb Data Analysis",
    "GMP Lamb Bookings": "GMP Lamb Bookings",
    "GMP Upload": "GMP Upload",
    "Data Analysis Overview": "Data Analysis Overview",
    "MEQ Live": "MEQ Live",
    "MEQ Probe": "MEQ Probe",
    "MEQ Camera": "MEQ Camera",
    "MEQ Live Genetics": "MEQ Live Genetics",
    "USDA Audit": "USDA Audit",
    "USDA Audit Feedback": "USDA Audit Feedback",
    "Management": "Management",
    "Record Labelling Admin": "Record Labelling",
    "Record Labelling": "My Assignments",
    "USDA Image Calibration": "USDA Image Calibration"
  },
  "timePeriods": {
    "twelveMonths": "12 months",
    "threeMonths": "3 months",
    "thirtyDays": "30 days",
    "sevenDays": "7 days",
    "selectDate": "Select date",
    "selectRange": "Date range",
    "customRange": "Custom range"
  },
  "footer": {
    "copyright": "Copyright © MEQ {{year}}",
    "termsAndConditions": "Terms & Conditions",
    "privacyPolicy": "Privacy Policy"
  },
  "pageTitles": {
    "administration": "Administration",
    "meqLiveAdmin": "MEQ Live Admin",
    "gmpLambDataAnalysis": "GMP Lamb Data Analysis",
    "gmpLambBooking": "GMP Lamb Booking",
    "gmpUpload": "GMP Upload",
    "meqDataAnalytics": "MEQ Data Analytics",
    "meqLive": "MEQ Live",
    "meqProbe": "MEQ Probe",
    "meqCamera": "MEQ Camera",
    "meqLiveGenetics": "MEQ Live Genetics",
    "usdaAudit": "USDA Audit",
    "usdaAuditFeedback": "USDA Audit Feedback",
    "recordLabelling": "Record Labelling",
    "myAssignments": "My Assignments",
    "usdaImageCalibration": "USDA Image Calibration",
    "management": "Management",
    "working": "Working ...",
    "noPackages": "No Packages",
    "notFound": "Not Found",
    "loading": "Loading",
    "login": "Login",
    "authCallback": "Auth Callback",
    "logout": "Logout"
  },
  "table": {
    "noRecordsToDisplay": "No records to display",
    "exportAllDataToCsv": "Export All Data to CSV",
    "search": "Search",
    "clearSearch": "Clear search",
    "selectAllRows": "Select all rows",
    "selectRow": "Select row",
    "collapseRow": "Collapse row",
    "expandRow": "Expand row",
    "showHideColumns": "Show/hide columns",
    "showHideAllColumns": "Show/hide all",
    "toggleDensity": "Toggle density",
    "toggleFullscreen": "Toggle fullscreen",
    "filterMin": "Min",
    "filterMax": "Max",
    "rowsPerPage": "Rows per page"
  },
  "columnNames": {
    "AA_MARBLING": "AA Marbling",
    "AGE": "Age",
    "AGREEMENT_RATE_PCT": "Agreement Rate %",
    "ANIMAL_PRODUCT_CODE": "Animal Product Code",
    "ANIMAL_PRODUCT_NAME": "Animal Product Name",
    "AUS_MARBLING": "AUS Marbling",
    "AVG_AUS_MARBLING": "Avg AUS Marbling",
    "AVG_EYE_MUSCLE_AREA": "Avg Eye Muscle Area",
    "AVG_FAT_COLOR": "Avg Fat Color",
    "AVG_HUMP_HEIGHT": "Avg Hump Height",
    "AVG_IMF": "Avg IMF",
    "AVG_IMF_PERCENTAGE_OF": "Avg IMF %",
    "AVG_JBS_WAGYU_MARBLING": "Avg JBS Wagyu Marbling",
    "AVG_MSA_MARBLING": "Avg MSA Marbling",
    "AVG_RIB_EYE_AREA": "Avg Rib Eye Area",
    "AVG_RIB_FAT": "Avg Rib Fat",
    "AVG_SUBCUTANEOUS_FAT": "Avg Subcutaneous Fat",
    "AVG_USDA_MARBLING": "Avg USDA Marbling",
    "AVG_YG": "Avg YG",
    "BARCODE": "Barcode",
    "BMS_MARBLING": "BMS Marbling",
    "BODY_NO": "Body No",
    "BODY_NUMBER": "Body Number",
    "CARCASE_HOTWEIGHT": "Carcase Hot Weight",
    "CARCASE_NOTE": "Carcase Note",
    "CARCASE_SIDE": "Carcase Side",
    "CHOICE_PCT": "Choice %",
    "CITY_NAME": "City Name",
    "COMPANY_CODE": "Company Code",
    "COUNT_AUS_MARBLING": "Total AUS Mb",
    "COUNT_EYE_MUSCLE_AREA": "Total EMA",
    "COUNT_IMF": "Total IMF",
    "COUNT_JBS_WAGYU_MARBLING": "Total Wagyu Mb",
    "COUNT_MSA_MARBLING": "Total MSA",
    "COUNT_RIB_EYE_AREA": "Total Rib Eye Area",
    "EID": "EID",
    "EYE_MUSCLE_AREA": "Eye Muscle Area",
    "EYE_MUSCLE_AREA_UNITS": "Eye Muscle Area Units",
    "FARMER_CODE": "Farmer Code",
    "FARMER_NAME": "Farmer Name",
    "FARM_CODE": "Farm Code",
    "FARM_NAME": "Farm Name",
    "FAT_COLOR": "Fat Color",
    "FINENESS": "Fineness",
    "FL_MARBLING": "FL Marbling",
    "FMP_MARBLING": "FMP Marbling",
    "GROUPED_PRODUCT_NAME": "Grouped Product Name",
    "HCW": "HCW",
    "HUMP_HEIGHT": "Hump Height",
    "IMF": "IMF %",
    "IMF_VISUAL": "IMF Visual",
    "IS_DCULITE": "Is DCU Lite",
    "JBS_WAGYU_MARBLING": "JBS Wagyu Marbling",
    "KEYFRAME_HASH": "Keyframe Hash",
    "KILL_DATE": "Kill Date",
    "KPH": "KPH",
    "LMY": "LMY %",
    "LOCATION": "Location",
    "LOTBATCH": "Lot/Batch",
    "MEAT_COLOR_4_PLUS": "% Meat Colour 4+",
    "MEAT_TYPE": "Meat Type",
    "MEQ_MEAT_COLOR": "MEQ Meat Color",
    "MSA_MARBLING": "MSA Marbling",
    "NOTE": "Note",
    "NUMBER_OF_IMAGES": "Number of Images",
    "OPERATOR_MEAT_COLOR": "Operator Meat Color",
    "OVERRIDE_AUS_MARBLING": "Override AUS Marbling",
    "OVERRIDE_BMS_MARBLING": "Override BMS Marbling",
    "OVERRIDE_EYE_MUSCLE_AREA": "Override Eye Muscle Area",
    "OVERRIDE_FAT_COLOR": "Override Fat Color",
    "OVERRIDE_IMF": "Override IMF %",
    "OVERRIDE_MSA_MARBLING": "Override MSA Marbling",
    "OVERRIDE_PCT": "Override %",
    "OVERRIDE_RIB_FAT": "Override Rib Fat",
    "OVERRIDE_USDA_MARBLING": "Override USDA Marbling",
    "PHOTO_DATE": "Photo Date",
    "PHOTO_DATETIME": "Photo Datetime",
    "PLANT_AUS": "Plant AUS Marbling",
    "PLANT_EMA": "Plant Eye Muscle Area",
    "PLANT_MSA": "Plant MSA Marbling",
    "PLANT_RIBFAT": "Plant Rib Fat",
    "PRIME_PCT": "Prime %",
    "PYG": "PYG",
    "RIB_EYE_AREA": "Rib Eye Area",
    "RIB_EYE_AREA_UNITS": "Rib Eye Area Units",
    "RIB_FAT": "Rib Fat",
    "RIB_FAT_UNITS": "Rib Fat Units",
    "SELECT_PCT": "Select %",
    "SEX": "Sex",
    "STATE_NAME": "State Name",
    "SUBCUTANEOUS_FAT": "Subcutaneous Fat",
    "SUPPLIER": "Supplier",
    "UNDERRIDE_PCT": "Underride %",
    "USDA_MARBLING": "USDA Marbling",
    "USER": "User",
    "YG": "YG"
  },
  "authSplash": {
    "headline": "Objective measurement intelligence,",
    "headlineAccent": "every shift.",
    "tagline": "MEQ Insights brings live animal measurement, camera grading, probe measurements and plant performance together — so your team makes the same call the data does.",
    "statValue": "4.2M",
    "statLabel": "Carcases graded",
    "welcome": "Welcome back",
    "subtitle": "Sign in to your MEQ Insights workspace.",
    "logIn": "Log in",
    "logOut": "Log out",
    "loading": "Loading..."
  },
  "authErrors": {
    "title": "We couldn't load MEQ Insights",
    "sessionCheckFailed": "We couldn't reach the sign-in service. Check your connection and try again.",
    "bootFailed": "Something went wrong while loading your account. Try again, or log out and sign in again.",
    "userNotFound": "We couldn't find a MEQ Insights account for this sign-in. Log out and sign in with a different account, or contact your administrator.",
    "noAccessibleOrgs": "Your account doesn't have access to any organisations yet. Contact your administrator, or log out and sign in with a different account.",
    "retry": "Try again",
    "logOut": "Log out"
  },
  "selectOrg": {
    "prompt": "Please select an organisation to continue",
    "placeholder": "Select an organisation",
    "legacyTitle": "Thank you",
    "legacyPrompt": "Please select an organisation to continue."
  },
  "outdatedClient": {
    "title": "Insights has been updated",
    "message": "This tab is running an older version of Insights. Please refresh the page to continue.",
    "action": "Refresh page"
  },
  "routeError": {
    "title": "Something went wrong",
    "message": "This page couldn't be displayed. We've been notified. Please refresh the page to try again.",
    "action": "Refresh page"
  }
}
